export const DELIVERY_METHODS = {
    BALANCED: 'BALANCED',
    ACCELERATED: 'ACCELERATED',
};
